module.exports = __webpack_public_path__ + "img/login-img.e01b1e94.png";